import { Card, CardMedia } from '@mui/material';

const UploadFilePreview = ({ file, type }) => {
  const src = file?.original_url || URL.createObjectURL(file);
  return (
    <Card>
      {type === 'image' && (
        <CardMedia
          component="img"
          image={src}
          alt="Preview"
          sx={{ height: 300, objectFit: 'contain' }}
        />
      )}
      {type === 'pdf' && <embed src={src} type="application/pdf" width="100%" height="300px" />}
    </Card>
  );
};

export default UploadFilePreview;
